module.exports = __webpack_public_path__ + "img/anak-benih-kelapa-pandan.b3addd86.png";